import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatDialogModule } from "@angular/material/dialog"; // Import MatDialogModule
import { Itinerary, ItineraryAttraction } from "../../models/itinerary";
import { AttractionEditorComponent } from "../common/attraction.editor/attraction.editor.component";
import { CalendarSharedModule } from "../../../shared/calendar.shared.module";
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray,
} from "@angular/cdk/drag-drop";
import { CreateItineraryComponent } from "../itinerary/create.itinerary/create.itinerary.component";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { AsyncPipe, NgForOf, NgIf } from "@angular/common";
import { SearchAttractionsComponent } from "../itinerary/search.attractions/search.attractions.component";
import { SharedModule } from "../../../shared/shared.module";
import { TourSimulationComponent } from "../itinerary/tour.simulation/tour.simulation.component";
import { VisitorPlace } from "../../../shared/models/visitor.place";
import { IMapMarkerWithCustomData } from "../../../shared/models/place.marker";
import { VisitorEvent } from "../../../shared/models/visitor.event";
import { Subscription, takeUntil } from "rxjs";
import { GoogleMapComponent } from "../../../shared/components/google.map/google.map.component";
import { BaseComponent } from "../../../../common/components/base.component";
import { ActivatedRoute } from "@angular/router";
import { FancyEventDetailsModalComponent } from "../../../event-calendar/components/event.details.modal/fancy.event.details.modal/fancy.event.details.modal.component";
import { IEventDetailsModalData } from "../../../event-calendar/components/event.details.modal/event.details.modal.provider";
import { FancyPlaceDetailsModalComponent } from "../../../place-calendar/components/place.details.modal/fancy.place.details.modal/fancy.place.details.modal.component";
import { IPlaceDetailsModalData } from "../../../place-calendar/components/place.details.modal/place.details.modal.provider";
import { ModalService } from "../../../../common/services/modal/modal.service";
import { ButtonTriggerEvent } from "../../../../common/components/button/button.component";
import { TripPlannerService } from "../../services/trip.planner.service";
import {
  ExportPDFService,
  ExportItineraryPDFCommand,
  PDFType,
} from "../../../shared/services/export.pdf.service";
import { SeoService } from "../../../../common/services/seo.service/seo.service";
import { MediaQueryService } from "../../../../common/services/media.query/media.query.service";
import { ItineraryDetailsStyleEditorComponent } from "../itinerary/itinerary.details.style.editor/itinerary.details.style.editor.component";
import { MapStyleSelectorComponent } from "../common/map.style.selector/map.style.selector.component";
import {
  ShareItineraryModalComponent,
  ShareItineraryModalData,
} from "../common/share.itinerary.modal/share.itinerary.modal.component";
import { removeHtmlTags } from "../../../../common/utils/string.extensions";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ConfirmDialogComponent } from "../../../../common/components/confirm.dialog/confirm.dialog.component";
import { isEmptyArray } from "src/app/common/utils/object.extensions";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormsModule } from "@angular/forms";
import { MatMenuTrigger } from "@angular/material/menu";
import { DirectionNavigationComponent } from "../itinerary/direction.navigation/direction.navigation.component";

@Component({
  selector: "ig-itinerary-details-modal",
  standalone: true,
  imports: [
    CalendarSharedModule,
    CdkDrag,
    CdkDropList,
    CreateItineraryComponent,
    MatIcon,
    MatTooltip,
    NgForOf,
    NgIf,
    SearchAttractionsComponent,
    SharedModule,
    TourSimulationComponent,
    AttractionEditorComponent,
    AsyncPipe,
    ItineraryDetailsStyleEditorComponent,
    MapStyleSelectorComponent,
    ConfirmDialogComponent,
    MatDialogModule,
    FormsModule,
    DirectionNavigationComponent,
  ],
  templateUrl: "./itinerary.details.modal.component.html",
  styleUrl: "./itinerary.details.modal.component.scss",
  encapsulation: ViewEncapsulation.ShadowDom,
  // providers: [
  //   {provide: MatDialogRef, useValue: {}}, // Provide MatDialogRef
  //   {provide: MAT_DIALOG_DATA, useValue: {}} // Provide MAT_DIALOG_DATA
  // ]
})
export class ItineraryDetailsModalComponent
  extends BaseComponent
  implements OnInit
{
  isMobile = false;
  isCssReady = false;

  mapMarkers: IMapMarkerWithCustomData<VisitorPlace | VisitorEvent>[] = [];
  defaultMapIconUrl = `https://iti-images.s3.amazonaws.com/imgs/map-icon.png`;
  directionResults: google.maps.DirectionsResult;
  directionLines: google.maps.Polyline[] = [];
  isShowSaveAttractionChanges = false;
  isChangesSaved = true;
  isJustAddedPlaces = false;
  isShowNotSaveConfirm = false;
  descriptionChangedAttractionIds: string[] = [];
  isAttractionsExpanded = true;
  isFoldItineraryTitle = true;
  isGeneratingPDF = false;
  isSharing = false;

  isMovieSimulateTourShowing = false;
  isMovieDisplayingAttractions = false;

  @Input() mode: "embed" | "popup" = "popup";
  @Input() tempDetailsStyle: "map" | "story" | undefined = undefined; // user can temporarily change the style of the details view, instead of loading 3d map
  @Input() currentItinerary: Itinerary = null;

  @ViewChild("virtual3DIframe", { static: false })
  virtual3DIframe: HTMLIFrameElement;
  virtual3DSrcSafe: SafeResourceUrl;
  virtual3DSrc = "https://dev.imgoingcalendar.com/virtual-3d-tour/index.html";
  // virtual3DSrc = 'http://127.0.0.1:5500/index.html?mode=normal';
  is3DMapLoaded = false;
  isHideSearchBarFor3DMap = false;
  isProcessingMsgFrom3DMap = false;

  @ViewChild("mapmask", { static: false }) mapMask: ElementRef;
  @ViewChild("storyMapWrap", { static: false }) storyMapWrap: ElementRef;
  @ViewChild("movieSimulator", { static: false })
  movieSimulator: TourSimulationComponent;
  @ViewChild(DirectionNavigationComponent, { static: false })
  directionNavigation: DirectionNavigationComponent;
  @ViewChild(GoogleMapComponent, { static: false })
  googleMap: GoogleMapComponent;
  @ViewChildren("attractioncard") attractionCards: QueryList<ElementRef>;

  @Output() onItineraryUpdate = new EventEmitter<any>();

  descPreviewCloseSubscription: Subscription;
  snackBar = inject(MatSnackBar);

  isShowGPSConfirm = false;
  isNavigationShowing = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    public tripService: TripPlannerService,
    public mediaQueryService: MediaQueryService,
    public pdfService: ExportPDFService,
    public seoService: SeoService,
    private _sanitizer: DomSanitizer,
    public modalService: ModalService,
    private renderer: Renderer2,
    private _snackBar: MatSnackBar,
    // public dialogRef: MatDialogRef<ItineraryDetailsModalComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: IItineraryDetailsData,
    @Optional() public dialogRef: MatDialogRef<ItineraryDetailsModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: IItineraryDetailsData
  ) {
    super({ activatedRoute });
  }

  ngOnInit() {
    this.currentItinerary =
      this.data?.currentItinerary || this.currentItinerary;
    this.tempDetailsStyle =
      this.data?.tempDetailsStyle || this.tempDetailsStyle;
    console.log("current", this.currentItinerary);
    console.log("mode", this.mode);

    if (this.mode === "embed") {
      this.data = {
        isEditMode: false,
        currentItinerary: this.currentItinerary,
      };

      this.modalService.injectStyle("ig-itinerary-details-modal", [], () => {
        this.isCssReady = true;
      });
    }

    if (this.mode === "popup") {
      // handle browser back button click, close the event details view and reload the page
      window.addEventListener("popstate", this.hashChanged.bind(this));

      // as this modal is ShadowDom, we need to inject the styles into it
      this.dialogRef.afterOpened().subscribe(() => {
        this.modalService.injectStyle(
          ".cdk-overlay-container ig-itinerary-details-modal",
          [],
          () => {
            this.isCssReady = true;
          }
        );
      });

      // notify itinerary.component.ts to reload itineraries
      this.dialogRef.beforeClosed().subscribe((data) => {
        this.descPreviewCloseSubscription &&
          this.descPreviewCloseSubscription.unsubscribe();

        window.removeEventListener("message", this._3DMapHandler);

        this.data.isEditMode &&
          TripPlannerService.sendData({
            type: "EDIT_MODE_CLOSE_DETAILS_MODAL",
            data: this.currentItinerary,
          });
      });

      // do not add nameId for embedding mode
      this.setNameIdAndSeo();

      setTimeout(() => {
        this.isFoldItineraryTitle = false;
      }, 2000);
    }

    // receive from AttractionDescriptionPreviewModalComponent in edit mode to reset status
    this.descPreviewCloseSubscription =
      TripPlannerService.modalClose$.subscribe((data) => {
        if (data && data.type === "ATTRACTION_DESCRIPTION_SAVED") {
          this.clearChangeStatus();
        }
      });

    this.mediaQueryService.isMobile$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((isMobile) => {
        this.isMobile = isMobile;
      });

    this.removeCardRotate();

    setTimeout(() => {
      this.setMapMarkers();

      this.virtual3DSrc = this.getVirtual3DUrl();
      if (this.data.isEditMode) {
        this.virtual3DSrc = this.virtual3DSrc.replace("normal", "edit");
      }
      if (
        !this.tempDetailsStyle &&
        this.currentItinerary.detailsStyle === "map3d"
      ) {
        this.virtual3DSrcSafe = this._sanitizer.bypassSecurityTrustResourceUrl(
          this.virtual3DSrc
        );
        this.loadMap3D();
      }
    });
  }

  get styleTextColor() {
    const dark = "#e5e7eb";
    const light = "#52525b";
    if (
      !this.tempDetailsStyle &&
      this.currentItinerary.detailsStyle === "map3d"
    ) {
      return dark;
    }
    return this.currentItinerary.mapStyle === "light" ? light : dark;
  }

  backToList() {
    if (!this.isChangesSaved) {
      console.log("not saved");
      this.isShowNotSaveConfirm = true;
      return;
    }
    this.dialogRef.close();
  }

  proceedClose() {
    this.clearChangeStatus();
    this.dialogRef.close();
  }

  clearChangeStatus() {
    this.isChangesSaved = true;
    this.isShowNotSaveConfirm = false;
    this.isShowSaveAttractionChanges = false;
    this.isJustAddedPlaces = false;
  }

  addPlace(item: VisitorPlace | VisitorEvent) {
    this.currentItinerary.attractions.push({
      feedId: item._id,
      feedType: item.startTime ? "event" : "place",
      order: this.currentItinerary.attractions.length,
      item: item,
    } as ItineraryAttraction);

    this.setMapMarkers();
    if (this.data.isEditMode) {
      this.isJustAddedPlaces = true;
      this.isChangesSaved = false;
      this.isShowSaveAttractionChanges = true;
    }
    this.removeCardRotate();

    if (
      !this.tempDetailsStyle &&
      this.currentItinerary.detailsStyle === "map3d"
    ) {
      this.sendItineraryUpdatedMsg();
    }
  }

  expandAttractions() {
    this.isAttractionsExpanded = !this.isAttractionsExpanded;
  }

  dropAttraction(event: CdkDragDrop<ItineraryAttraction[]>) {
    moveItemInArray(
      this.currentItinerary.attractions,
      event.previousIndex,
      event.currentIndex
    );
    this.currentItinerary.attractions.forEach((attraction, index) => {
      attraction.order = index;
    });
    this.setMapMarkers();
    if (this.data.isEditMode) {
      this.isShowSaveAttractionChanges = true;
      this.isChangesSaved = false;
    }
  }

  removeCardRotate() {
    // remove rotate effect for attraction cards, otherwise it blocks the drag/drop
    setTimeout(() => {
      for (const card of this.attractionCards) {
        this.renderer.removeClass(card.nativeElement, "ig-rotate-180");
      }
    }, 2000);
  }

  showDetails(attraction: ItineraryAttraction) {
    if (attraction.feedType === "event") {
      this.modalService.show({
        component: FancyEventDetailsModalComponent,
        panelClass: "ig-modal-w-full",
        data: {
          currentEvent: attraction.item,
          allEvents: [],
          favCustomEvents: [],
          from: "itinerary",
        } as IEventDetailsModalData,
      });
    } else {
      this.modalService.show({
        component: FancyPlaceDetailsModalComponent,
        panelClass: "ig-modal-w-full",
        data: {
          currentPlace: attraction.item,
          from: "itinerary",
        } as IPlaceDetailsModalData,
      });
    }
  }

  hoverAttraction(attraction: ItineraryAttraction) {
    this.googleMap?.closeInfoWindow();

    if (this.isMovieSimulateTourShowing) return;

    const marker = this.googleMap.mapMarkerObjs.find(
      (x) => x.getTitle() === attraction.item._id
    );

    if (attraction.feedType === "event") {
      this.googleMap.showEventInfoWindow(marker, {
        ...marker,
        data: attraction.item,
      } as IMapMarkerWithCustomData<VisitorEvent>);
    } else {
      this.googleMap.showPlaceInfoWindow(marker, {
        ...marker,
        data: attraction.item,
      } as IMapMarkerWithCustomData<VisitorPlace>);
    }
  }

  attractionDescriptionChanged(newDesc: string, stop: ItineraryAttraction) {
    stop.item.description = newDesc;
    this.descriptionChangedAttractionIds.push(stop.item._id);
    console.log("attractionDescriptionChanged", stop.item._id);
    console.log(
      "this.descriptionChangedAttractionIds",
      this.descriptionChangedAttractionIds
    );
    this.isShowSaveAttractionChanges = true;
    this.isChangesSaved = false;
  }

  removeAttraction(attraction: ItineraryAttraction) {
    const index = this.currentItinerary.attractions.indexOf(attraction);
    if (index > -1) {
      this.currentItinerary.attractions.splice(index, 1);
      this.setMapMarkers();
    }
    if (this.data.isEditMode) {
      this.isShowSaveAttractionChanges = true;
      this.isChangesSaved = false;
    }
  }

  saveDescriptions(event: ButtonTriggerEvent) {
    this.tripService
      .updateItineraryAttractions(
        this.hubName,
        this.currentItinerary._id,
        this.currentItinerary.attractions,
        this.descriptionChangedAttractionIds
      )
      .pipe()
      .subscribe(() => {
        event.success();
        this.isJustAddedPlaces = false;
        this.isChangesSaved = true;
        setTimeout(() => {
          this.isShowSaveAttractionChanges = false;
        }, 5000);
      });
  }

  removeHtml(content: string) {
    return removeHtmlTags(content);
  }

  itineraryUpdated(itinerary: Itinerary) {
    this.setMapMarkers();
    this.onItineraryUpdate.emit();

    if (
      !this.tempDetailsStyle &&
      this.currentItinerary.detailsStyle === "map3d"
    ) {
      this.sendItineraryUpdatedMsg();
    }
  }

  detailsStyleChanged($event) {
    if (this.currentItinerary.detailsStyle === "map3d") {
      // this.loadMap3D();
      // notify itinerary.component.ts to reload itineraries
      this.dialogRef.beforeClosed().subscribe((data) => {
        this.descPreviewCloseSubscription &&
          this.descPreviewCloseSubscription.unsubscribe();

        this.data.isEditMode &&
          TripPlannerService.sendData({
            type: "RELOAD_3DMAP_ITINERARY",
            data: this.currentItinerary,
          });
      });

      this.dialogRef.close();
    }
  }

  private leanMap() {
    this.googleMap.fitBounds();
    this.googleMap.googleMap.googleMap.setZoom(
      this.googleMap.googleMap.googleMap.getZoom() - 0.5
    );
    this.googleMap.googleMap.googleMap.panBy(-150, 0);
    this.googleMap.googleMap.googleMap.setTilt(60);
  }

  markerClick($event) {
    this.googleMap.showPlaceInfoWindow();
  }

  travelMode(trigger: MatMenuTrigger) {
    this.movieSimulator?.stop();
    this.directionNavigation?.exit();
    this.setMapMarkers();
    setTimeout(() => {
      trigger?.closeMenu();
    }, 500);
  }

  gpsDirections() {
    this.movieSimulator?.stop();
    this.isShowGPSConfirm = false;
    this.directionNavigation.navigateFromUserGPSLocation();
  }
  directions() {
    this.isShowGPSConfirm = false;
    this.isFoldItineraryTitle = true;
    this.isNavigationShowing = true;
    this.movieSimulator?.stop();

    this.storyMapWrap?.nativeElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    this.directionNavigation.nextLeg();
  }

  movie360() {
    this.directionNavigation?.exit();
    this.movieSimulator?.movie360();
  }

  movie360Start() {
    this.isFoldItineraryTitle = true;
    this.isAttractionsExpanded = false;
    this.isMovieSimulateTourShowing = true;
    this.googleMap.fitBounds();

    this.storyMapWrap?.nativeElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  movie360End() {
    this.isMovieSimulateTourShowing = false;
  }

  async exportPDF() {
    if (this.isGeneratingPDF) return;

    this.isGeneratingPDF = true;
    let command = new ExportItineraryPDFCommand();
    command.hubName = this.hubName;
    command.type = PDFType.tour;
    command.topImage = this.currentItinerary.image;
    console.log("this.currentItinerary", this.currentItinerary);
    command.trips = [this.currentItinerary];

    try {
      await this.pdfService.exportItineraryPDF(command);
    } catch (e) {
      alert(e.message);
      console.log(e);
    } finally {
      this.isGeneratingPDF = false;
    }
  }

  shareItinerary() {
    // if (this.isSharing) return;

    this.isSharing = true;
    const dialog = this.modalService.show({
      component: ShareItineraryModalComponent,
      // panelClass: 'ig-modal-w-full',
      data: {
        itinerary: this.currentItinerary,
        hubName: this.hubName,
        cityName:
          this.frontendSettings?.ai?.travelBuddy?.cityName || this.hubName,
        isEditMode: this.data.isEditMode,
        type: "itinerary",
      } as ShareItineraryModalData,
    });

    dialog.beforeClosed().subscribe((data) => {
      this.isSharing = false;
    });
  }

  getVirtual3DUrl() {
    if (window.location.href.includes("localhost")) {
      // return 'http://127.0.0.1:5500/index.html?mode=normal';
      return "http://127.0.0.1:5500/IMGoing-next/web/src/virtual-3d-tour/index.html?mode=normal";
    }
    if (window.location.href.includes("devnext")) {
      return "https://devnext.imgoingcalendar.com/virtual-3d-tour/index.html?mode=normal";
    }
    return "https://next.imgoingcalendar.com/virtual-3d-tour/index.html?mode=normal";
  }

  sendMessageToIframe(message: any) {
    console.log("this.virtual3DSrc", this.virtual3DSrc);
    console.log("message", message);
    this.virtual3DIframe["nativeElement"].contentWindow.postMessage(
      message,
      this.virtual3DSrc
    );
  }

  _3DMapHandler = async (event) => {
    console.log("postMessage in details: ", event);

    if (
      [
        "https://localhost:4201",
        "http://127.0.0.1:5500",
        "https://dev.imgoingcalendar.com",
        "https://imgoingcalendar.com",
        "https://next.imgoingcalendar.com",
        "https://devnext.imgoingcalendar.com",
      ].some((x) => event.origin.startsWith(x))
    ) {
      if (this.isProcessingMsgFrom3DMap) return;
      this.isProcessingMsgFrom3DMap = true;

      try {
        if (event.data.type === "3D_MAP_LOADED") {
          this.is3DMapLoaded = true;
        }
        if (event.data.type === "ENTER_EDIT_ATTRACTION") {
          this.isHideSearchBarFor3DMap = true;
        }
        if (event.data.type === "LEAVE_EDIT_ATTRACTION") {
          this.isHideSearchBarFor3DMap = false;
        }
        if (event.data.type === "DELETE_ATTRACTION") {
          this.currentItinerary.attractions =
            this.currentItinerary.attractions.filter(
              (x) => x.feedId !== event.data.attractionId
            );
          this.isShowSaveAttractionChanges = true;
          this.isChangesSaved = false;
        }
        if (event.data.type === "REORDER_ATTRACTION") {
          this.currentItinerary.attractions.sort((a, b) => {
            const indexA = event.data.attractionIds.indexOf(a.feedId);
            const indexB = event.data.attractionIds.indexOf(b.feedId);
            return indexA - indexB;
          });

          this.isShowSaveAttractionChanges = true;
          this.isChangesSaved = false;
        }
        if (event.data.type === "EXPORT_PDF") {
          await this.exportPDF();
          this.sendItineraryOperationCompletedMsg();
        }
        if (event.data.type === "SHARE_ITINERARY") {
          this.shareItinerary();
        }
        if (event.data.type === "GPS_DIRECTIONS") {
          this.gpsDirections();
        }
        if (event.data.type === "EDIT_ITINERARY_SUCCESS") {
          this._snackBar.open(
            `All changes have been saved successfully.`,
            "Close",
            {
              horizontalPosition: "center",
              verticalPosition: "top",
              panelClass: "ig-success-snackbar",
              duration: 4000,
            }
          );
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isProcessingMsgFrom3DMap = false;
      }
    }
  };
  loadMap3D() {
    console.log("going to add message listener");

    window.removeEventListener("message", this._3DMapHandler);
    window.addEventListener("message", this._3DMapHandler);
    // send multiple times to make sure the map is loaded
    this.sendLoad3DMapMsg(1000);
    this.sendLoad3DMapMsg(3000);
    this.sendLoad3DMapMsg(5000);
    this.sendLoad3DMapMsg(9000);
  }

  sendLoad3DMapMsg(delay: number = 1000) {
    setTimeout(() => {
      this.sendMessageToIframe({
        type: "LOAD_ITINERARY",
        hubName: this.hubName,
        itineraryId: this.currentItinerary._id,
        origin: window.location.origin,
      });
    }, delay);
  }
  sendItineraryUpdatedMsg() {
    this.sendMessageToIframe({
      type: "ITINERARY_UPDATED",
      hubName: this.hubName,
      itinerary: this.currentItinerary,
    });
  }

  sendItineraryOperationCompletedMsg() {
    this.sendMessageToIframe({
      type: "ITINERARY_COMPLETED",
    });
  }

  updateMapIcons() {
    let index = 1;
    this.mapMarkers = [];
    for (const attraction of this.currentItinerary.attractions) {
      const mapIcon = attraction.mapIcon || this.defaultMapIconUrl;
      this.mapMarkers.push({
        position: {
          lat: attraction.item.address?.lat,
          lng: attraction.item.address?.lng,
        },
        options: {
          // icon: icons[attraction.item.name],
          icon: {
            url: mapIcon,
            scaledSize: mapIcon.includes(
              "iti-images.s3.amazonaws.com/imgs/map-icon"
            )
              ? new google.maps.Size(40, 55)
              : undefined,
          },
          zIndex: 2,
        },
        title: attraction.item._id, // use this for showing map info window when hovering on list items, see hoverAttraction function
        data: attraction.item,
      } as IMapMarkerWithCustomData<VisitorPlace | VisitorEvent>);

      // for the yellow order marker
      this.mapMarkers.push({
        position: {
          lat: attraction.item.address?.lat,
          lng: attraction.item.address?.lng,
        },
        options: {
          icon: {
            url: "https://imgoingcalendar.com/assets/imgs/tp-marker-2.png",
            anchor: new google.maps.Point(30, 50),
            scaledSize: new google.maps.Size(25, 25),
          } as google.maps.Icon,
          zIndex: 10,
          // optimized: true,
        },
        label: {
          text: (index++).toString(),
          fontWeight: "bold",
        },
      } as IMapMarkerWithCustomData<VisitorPlace | VisitorEvent>);
    }

    setTimeout(() => {
      this.mapMask && (this.mapMask.nativeElement.style.opacity = 0);
    }, 1500);
    setTimeout(() => {
      this.mapMask && (this.mapMask.nativeElement.style.height = 0);
      this.mapMask && (this.mapMask.nativeElement.style.width = 0);
    }, 2000);

    if (this.data.isEditMode) {
      this.isShowSaveAttractionChanges = true;
      this.isChangesSaved = false;
    }
  }

  setNameIdAndSeo() {
    !this.data.isEditMode &&
      this.seoService.addNameIdToUrlForItinerary(
        this.currentItinerary,
        this.hubName,
        this.dialogRef
      );
  }

  setMapMarkers() {
    this.mapMarkers = [];

    let directionLocations: { lat; lng; stopover }[] = [],
      index = 1;
    for (const attraction of this.currentItinerary.attractions) {
      const mapIcon = attraction.mapIcon || this.defaultMapIconUrl;
      this.mapMarkers.push({
        position: {
          lat: attraction.item.address?.lat,
          lng: attraction.item.address?.lng,
        },
        options: {
          // icon: icons[attraction.item.name],
          icon: {
            url: mapIcon,
            scaledSize: mapIcon.includes(
              "iti-images.s3.amazonaws.com/imgs/map-icon"
            )
              ? new google.maps.Size(40, 55)
              : undefined,
          },
          zIndex: 2,
        },
        title: attraction.item._id, // use this for showing map info window when hovering on list items, see hoverAttraction function
        data: attraction.item,
      } as IMapMarkerWithCustomData<VisitorPlace | VisitorEvent>);

      // for the yellow order marker
      this.mapMarkers.push({
        position: {
          lat: attraction.item.address?.lat,
          lng: attraction.item.address?.lng,
        },
        options: {
          icon: {
            url: "https://imgoingcalendar.com/assets/imgs/tp-marker-2.png",
            anchor: new google.maps.Point(30, 50),
            scaledSize: new google.maps.Size(25, 25),
          } as google.maps.Icon,
          zIndex: 10,
          // optimized: true,
        },
        label: {
          text: (index++).toString(),
          fontWeight: "bold",
        },
        data: attraction.item,
      } as IMapMarkerWithCustomData<VisitorPlace | VisitorEvent>);

      directionLocations.push({
        lat: attraction.item.address?.lat,
        lng: attraction.item.address?.lng,
        stopover: true,
      });
    }

    setTimeout(() => {
      this.mapMask && (this.mapMask.nativeElement.style.opacity = 0);
    }, 500);
    setTimeout(() => {
      this.googleMap?.drawDirectionRoute(
        directionLocations,
        this.currentItinerary.defaultTravelMode.mode as google.maps.TravelMode
      );
      this.mapMask && (this.mapMask.nativeElement.style.height = 0);
      this.mapMask && (this.mapMask.nativeElement.style.width = 0);

      this.googleMap?.directionsResults$
        ?.pipe(takeUntil(this.isDestroyed))
        .subscribe((result) => {
          // only one attraction
          if (!result) {
            this.currentItinerary.travelTime = 0;
            this.currentItinerary.distance = 0;
            return;
          }

          if (isEmptyArray(result.routes)) {
            this.snackBar.open(
              "Could not load the direction route, please try again or select another travel mode.",
              "Close",
              {
                horizontalPosition: "center",
                verticalPosition: "bottom",
                panelClass: "ig-error-snackbar",
              }
            );
            return;
          }

          this.directionResults = result;
          let totalDistance = 0,
            totalDuration = 0;
          for (const leg of result.routes[0].legs) {
            totalDistance += leg.distance.value;
            totalDuration += leg.duration.value;
          }
          this.currentItinerary.travelTime = totalDuration;
          this.currentItinerary.distance = totalDistance;

          console.log("travelTime", this.currentItinerary.travelTime);
          console.log("distance", this.currentItinerary.distance);

          // move map to a little right, as left side has the attraction panel
          setTimeout(() => {
            !this.isMobile &&
              this.googleMap?.googleMap?.googleMap?.panBy(-150, 0);
          }, 20);
          console.log("directionsResults$", result);
        });
    }, 1000);
  }

  /**
   * handle browser back button click, close the place details page
   * only close the details page is not enough, it will always have other loading issues for the script embedding solution
   * so force reload the page for now
   * */
  // @HostListener('window:popstate', ['$event'])
  public hashChanged($event: Event) {
    $event.preventDefault();
    let url = window.location.href.split("imgoing-place")[0];
    url = url.endsWith("?") ? url.substring(0, url.length - 1) : url;
    window.location.href = url;
    this.backToList();
  }
}

export interface IItineraryDetailsData {
  currentItinerary: Itinerary;
  tempDetailsStyle?: "map" | "story";
  isEditMode: boolean;
}
